import { render } from "./OfflineScreen.vue?vue&type=template&id=2a1b2bbe&scoped=true"
import script from "./OfflineScreen.vue?vue&type=script&lang=js"
export * from "./OfflineScreen.vue?vue&type=script&lang=js"

import "./OfflineScreen.vue?vue&type=style&index=0&id=2a1b2bbe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a1b2bbe"]])

export default __exports__